"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateSavedJobsContract = void 0;
/* eslint-disable perfectionist/sort-objects */
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../../schemas");
const jobs_request_1 = require("../jobs.request");
const saved_job_request_1 = require("./saved-job.request");
const saved_job_response_1 = require("./saved-job.response");
const c = (0, core_1.initContract)();
exports.CandidateSavedJobsContract = c.router({
    save: {
        method: 'PUT',
        path: '/saved-jobs/:jobId',
        pathParams: jobs_request_1.JobIdPathParamsSchema,
        body: schemas_1.EmptyBodySchema,
        responses: {
            201: schemas_1.BaseResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    remove: {
        method: 'DELETE',
        path: '/saved-jobs/:jobId',
        pathParams: jobs_request_1.JobIdPathParamsSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    findMany: {
        method: 'GET',
        path: '/saved-jobs',
        query: saved_job_request_1.SavedJobListQuerySchema,
        responses: {
            200: saved_job_response_1.SavedJobListResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
        },
    },
});
